import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";



const firebaseConfig = {
    apiKey: "AIzaSyB77ApwJsYTOu_YsCY09kBSfY6DjS05feE",
    authDomain: "pasti-stok.firebaseapp.com",
    projectId: "pasti-stok",
    storageBucket: "pasti-stok.firebasestorage.app",
    messagingSenderId: "580771070670",
    appId: "1:580771070670:web:023fe29dbcb13f1763c69f",
    measurementId: "G-FHWLBMY009"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app); // Inisialisasi Storage
let analytics = null;
if (typeof window !== "undefined") {
    // check kalau environment support
    isSupported().then((yes) => {
        if (yes) {
            analytics = getAnalytics(app);
        }
    });
}

export { db, analytics, storage };
